import { render, staticRenderFns } from "./EbCargoInfoBill.vue?vue&type=template&id=9c88e33e&scoped=true&"
import script from "./EbCargoInfoBill.vue?vue&type=script&lang=js&"
export * from "./EbCargoInfoBill.vue?vue&type=script&lang=js&"
import style0 from "./EbCargoInfoBill.vue?vue&type=style&index=0&id=9c88e33e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c88e33e",
  null
  
)

export default component.exports